import { Field } from "@qid/field";
import { MetaData } from "@qid/core";
import { CollectionTemplateAgreement } from "./CollectionTemplateAgreement";
import { Organisation } from "../../organisation";
import { IdentityVerificationSettings } from "../interface/identity-verification-settings.interface";


export class CollectionTemplate extends MetaData {
  _id: string;
  createdBy: string;
  displayPicture: string;
  purpose: string;
  acceptedIds: Field[];
  otherInfo: Field[];
  isAtLeastOneAmongOptional: boolean;
  isPublic: boolean;
  org: Organisation;
  defaultScanner: string;
  isScannerLoading;
  isSignature: boolean;
  isQuotaLocked: boolean;

  isIdentityVerification: boolean;
  identityVerificationSettings: IdentityVerificationSettings;
  isEmailRequired: boolean = true
  isPhoneRequired: boolean = false;
  isOtpVerification: boolean = false;

  allowGroup: boolean;
  isParticipantEmailRequired: boolean;
  isParticipantSignature: boolean;
  isParticipantPhoneRequired: boolean;

  agreements: CollectionTemplateAgreement[];
  customTemplateForGroup: boolean;
  participantAcceptedIds: Field[];
  participantOtherInfo: Field[];

  postSubmissionRedirectUrl: string
  successfulMessage: string;

  webhookUrl?: string;
  webhookSecret?: string;
  webhookIdentifier?: string;

  type: 'check-in' | 'onboarding';

  isSelfieVerification: boolean

  uiVersion?: number

  /** Automation flags enabled for this form (e.g. `TIME`, `c-form`). */
  automations?: string[];

  constructor() {
    super();
  }
}
